const mergeThings = (...thingArrays) =>
	thingArrays
		.reduce((things, thingArray) => [...things, ...(thingArray || [])], [])

export default mergeThings



// WEBPACK FOOTER //
// ./src/utilities/Data/mergeThings.js